import { SiteBuilderDialog } from '../../sitebuilder-dialog/SiteBuilderDialog';
import { i, img } from '../../utils/html-builders';

export function init() {
  const lightboxLinks = document.querySelectorAll('.id7-main-content-area a[rel^=lightbox]');
  if (lightboxLinks.length > 0) {
    // Create and init dialog
    const imageDialogWrapper = SiteBuilderDialog.blankDialog({
      wrapperId: 'image-modal-wrapper',
      dialogId: 'image-modal',
      dialogClasses: 'image-modal maximised',
      title: 'Viewing image',
    });
    const dialogBody = imageDialogWrapper.querySelector('.dialog-body');
    const dialogFooter = imageDialogWrapper.querySelector<HTMLElement>('.dialog-footer');

    document.body.appendChild(imageDialogWrapper);

    const leftArrow = i({class: 'image-controls left fa fa-chevron-left fa-2x', 'aria-hidden': 'true'});
    const rightArrow = i({class: 'image-controls right fa fa-chevron-right fa-2x', 'aria-hidden': 'true'});

    dialogBody.appendChild(leftArrow);
    dialogBody.appendChild(rightArrow);

    lightboxLinks.forEach((link, index) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        showImage(index, link.querySelector('img').getAttribute('title'));
        SiteBuilderDialog.whenWrapperDefined(() => {
          imageDialogWrapper.showModal();
        });
      });
    });

    // Show next or previous image, direction is -1 for left or +1 for right
    function showNextImage(direction: number) {
      const currentImage = dialogBody.querySelector('img:not(.hidden)');
      const currentIndex = parseInt(currentImage.getAttribute('data-image-index'), 10);
      let newIndex = currentIndex + direction;
      if (newIndex < 0) { newIndex = 0 }
      if (newIndex > lightboxLinks.length - 1) { newIndex = lightboxLinks.length - 1 }
      showImage(newIndex, lightboxLinks[newIndex].querySelector('img').getAttribute('title'));
    }

    leftArrow.addEventListener('click', () => {
      showNextImage(-1);
    });

    rightArrow.addEventListener('click', () => {
      showNextImage(1);
    });

    document.addEventListener('keydown', (event) => {
      if (imageDialogWrapper.open) {
        if (event.key === 'ArrowLeft' || event.key === 'Left') {
          showNextImage(-1);
        }
        if (event.key === 'ArrowRight' || event.key === 'Right') {
          showNextImage(1);
        }
      }
    });

    function showImage(index: number, text: string) {
      const link = lightboxLinks[index] as HTMLAnchorElement;
      const url = link.href.split('?')[0];
      const oldParams = new URLSearchParams(link.href.split('?')[1]);
      const newParams = new URLSearchParams();
      const forbiddenParamKeys = ['maxwidth', 'maxheight'];

      oldParams.forEach((value, key) => {
        if (!forbiddenParamKeys.includes(key.toLowerCase())) {
          newParams.append(key, value);
        }
      });

      let image = dialogBody.querySelector(`img[data-image-index="${index}"]`)

      if (!image) {
        const image = img({src: `${url}?${newParams}`, 'data-image-index': index.toString(10), alt: ''});
        dialogBody.appendChild(image);
      }

      // Hide all other images
      dialogBody.querySelectorAll('img').forEach(imgElement => {
        (imgElement as HTMLImageElement).classList.toggle('hidden', imgElement.getAttribute('data-image-index') !== index.toString(10));
      });

      dialogFooter.innerText = text;
      leftArrow.classList.toggle('hidden', index === 0);
      rightArrow.classList.toggle('hidden', index === lightboxLinks.length - 1);
    }
  }
}
